import rates from '../data/portvilleMoveOutRates.json';

export interface MoveOutCharge {
  supplyAmount: number;
  vat: number;
  total: number;
}

export interface MoveOutCharges {
  inspectionDate: string;
  daysInMonth: number;
  chargeDays: number;
  communicationUsed: boolean;
  includePreviousMonth?: boolean;
  management: MoveOutCharge;
  electricity: MoveOutCharge;
  water: MoveOutCharge;
  communication: MoveOutCharge;
  total: number;
  depositAccount: string | null;
  rateSource: string;
}

export const getMoveOutInspectionDate = (now = new Date()): string => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit', day: '2-digit'
  }).formatToParts(now);
  const part = (type: string) => parts.find(value => value.type === type)!.value;
  return `${part('year')}-${part('month')}-${part('day')}`;
};

export const calculateMoveOutCharges = (inspectionDate: string, communicationUsed: boolean, includePreviousMonth = false): MoveOutCharges => {
  const [year, month, day] = inspectionDate.split('-').map(Number);
  const daysInMonth = new Date(Date.UTC(year, month, 0)).getUTCDate();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(inspectionDate) || month < 1 || month > 12 || day < 1 || day > daysInMonth) {
    throw new Error('유효하지 않은 퇴거점검일입니다.');
  }
  // 월 1일부터 점검 당일까지(당일 포함), 문서의 해당 일수 행을 그대로 사용한다.
  const table = month === 2 ? rates.tables.february : daysInMonth === 30 ? rates.tables['30'] : rates.tables['31'];
  const management = { ...table[day - 1] };
  if (includePreviousMonth) {
    management.supplyAmount += 86500;
    management.vat += 8650;
    management.total += 95150;
  }
  const months = includePreviousMonth ? 2 : 1;
  const electricity = { supplyAmount: 14800 * months, vat: 1480 * months, total: 16280 * months };
  const water = { supplyAmount: 10000 * months, vat: 0, total: 10000 * months };
  const communication = communicationUsed
    ? { supplyAmount: 10000 * months, vat: 1000 * months, total: 11000 * months }
    : { supplyAmount: 0, vat: 0, total: 0 };
  return {
    inspectionDate, daysInMonth, chargeDays: day, communicationUsed, includePreviousMonth,
    management, electricity, water, communication,
    total: management.total + electricity.total + water.total + communication.total,
    depositAccount: rates.depositAccount,
    rateSource: rates.source
  };
};
